import { directionGroupApi, usersAPI } from '@/api'
import { ManageGroupType } from '../../../types'
import { ApiResult } from '@modals/RequiredEmailConfirmation/components/RequiredEmailConfirmationModal/utils/api'
import { UpdateGroupSettingsPayload } from './types'

const mapSelectOptions = (items: any[]) =>
  items.map((item) => ({
    label: String(item.name ?? item.label ?? ''),
    value: String(item.id ?? item.value),
  }))

export const getAdditionalTeacherOptions = async (
  franchiseId?: number | null,
) => {
  const response = await usersAPI.searchUsersForSelect({
    employeesOnly: 1,
    'per-page': '1000',
    ...(franchiseId ? { franchise_id: franchiseId } : {}),
  })

  return mapSelectOptions(response?.data?.data ?? [])
}

export const getColleagueOptions = async () => {
  const response = await usersAPI.getColleaguesForGroup({ name: '' })
  const colleagues = response?.data?.data ?? []

  return {
    teachers: mapSelectOptions(colleagues),
    supervisors: mapSelectOptions(
      colleagues.filter((item: IColleague) =>
        item.roles?.includes('senior-seminarian'),
      ),
    ),
  }
}

export const saveGroupSettings = async (
  group: ManageGroupType,
  payload: UpdateGroupSettingsPayload,
): Promise<ApiResult<ManageGroupType>> => {
  try {
    const response = await directionGroupApi.updateSettings(group.id, payload)
    const success =
      response?.data?.status === 'success' || response?.data?.success === true

    return {
      data: response?.data?.data ?? null,
      success,
      error:
        response?.data?.error ||
        response?.data?.message ||
        'Не удалось сохранить настройки группы',
    }
  } catch (error) {
    return {
      data: null,
      success: false,
      error: error instanceof Error ? error.message : String(error),
    }
  }
}
